import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  DialogContentText
} from '@material-ui/core';
import Button from "@components/common/button/Button";
import * as React from 'react';

import TranslateNew from '@translate/TranslateNew';
const tn :TranslateNew = TranslateNew.getInstance();

interface IProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: () => void;
}


class EraseAccountDialog extends React.Component<IProps, {}> {
  public static defaultProps = {
    isOpen: false
  };

  constructor(props:any) {
    super(props);
  }

  public render() {
    return (
      <Dialog
        open={this.props.isOpen}
        onClose={this.props.onClose}
      >
        <DialogTitle>
          {tn.lang.eraseAccount}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            {tn.lang.eraseAccountSure}
          </DialogContentText>
          <DialogContentText>
            {tn.lang.eraseAccountSurePt2}
          </DialogContentText>
        </DialogContent>
        <DialogActions style={{justifyContent: "center", flexDirection: "column", gap: "10px", margin: "8px"}}>
        

          <Button style={{height: "35px"}} variant='contained' color='secondary' onClick={this.props.onSubmit}>{tn.lang.eraseAccountYes}</Button> 
          <Button variant='outlined' onClick={this.props.onClose}>{tn.lang.cancel}</Button>
    
        
        </DialogActions>
      </Dialog>
  
    );
  }
}

export default EraseAccountDialog;



// WEBPACK FOOTER //
// ./src/components/settings/eraseaccount.component.tsx